import { isMacOs } from "react-device-detect";

export const modifierKey = isMacOs ? "⌘" : "Ctrl";
